import { ThunkAction } from 'redux-thunk';
import { network } from '@imodules/helix';

import { getLeaderboardErrors, getLeaderboardInstanceSettings, getApiPollingTimeInterval } from '../selectors';
import { actions, types } from '../actions';
import { actions as leaderboardActions } from 'leaderboards';
import { LeaderboardAmbassadorDataApi, LeaderboardDataApi } from '../requests';
import { Action } from 'redux';

function getStringDateFormat(startDate: string): string {
    const date = new Date(startDate);
    return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
}

export const initiateLeaderboardPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        let errors = getLeaderboardErrors(getState());
        while (errors < 5) {
            const request = dispatch(pollLeaderboard());
            try {
                await request;
            } catch {
                dispatch({ type: types.API_CALL_FAILURE });
                errors = getLeaderboardErrors(getState());
            }
            const timeInterval = getApiPollingTimeInterval(getState());
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollLeaderboard = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        // const timeInterval = getApiPollingTimeInterval(getState());
        const settings: LeaderboardSettingsDto | undefined = getLeaderboardInstanceSettings(getState());

        if (settings) {
            const initiativeIds = settings.selectedControlIds.toString();
            if (settings.scoreboardTypeId === 13) {
                dispatch(await makeAmbassadorRequest(initiativeIds));
            } else {
                dispatch(await makeLeaderboardRequest(settings.scoreboardInstanceSettingsId));
            }
        }
    };
};

export const makeAmbassadorRequest = (initiativeIds: string): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const settings: LeaderboardSettingsDto | undefined = getLeaderboardInstanceSettings(getState());
        if (settings) {
            const endMoment = getStringDateFormat(settings.transactionEndDateTime ? settings.transactionEndDateTime.toString() : new Date().toString());
            const startDateTime = getStringDateFormat(settings.transactionStartDateTime.toString());
            const request = LeaderboardAmbassadorDataApi.createGetRequest(initiativeIds, startDateTime, endMoment);
            const result: any = await network.call(request); //NetworkRequestResponse<SortableLeaderboardDataRecord[]>

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(leaderboardActions.populateLeaderboardData(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        }
    };
};

export const makeLeaderboardRequest = (scoreboardInstanceSettingsId: number): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        const request = LeaderboardDataApi.createGetRequest(scoreboardInstanceSettingsId);
        const result: any = await network.call(request); //NetworkRequestResponse<SortableLeaderboardDataRecord[]>

        if (result.error) {
            dispatch(actions.apiCallFailure(result.error.message));
        } else {
            dispatch(leaderboardActions.populateLeaderboardData(result.response.content));
            dispatch(actions.apiCallSuccess());
        }
    };
};
export const watchLeaderboardData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateLeaderboardPolling());
    };
};